/**
 * LogoMark — radial mark (Option J).
 * Six rays from a center point. Five neutral, one teal at top — the critical ray.
 * Locked in chat 1.14, Apr 30 2026. Master geometry: 100x100 viewBox.
 *
 * Color tokens come from props so the same component renders correctly
 * on navy backgrounds (TopBar) and on white backgrounds (AuthLayout).
 *
 * Default colors are tuned for navy backgrounds (white rays + teal critical + white dot).
 * Pass variant="onWhite" for use on white surfaces (navy rays + teal critical + navy dot).
 */
export function LogoMark({ size = 40, variant = "onNavy" }) {
  const stroke = variant === "onWhite" ? "#0B1F36" : "#FFFFFF";
  const dot    = variant === "onWhite" ? "#0B1F36" : "#FFFFFF";
  const accent = "#1A9E8F";

  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true" focusable="false">
      <g strokeLinecap="round" fill="none">
        <line x1="64.72" y1="41.5" x2="80.31" y2="32.5" stroke={stroke} strokeWidth="5" />
        <line x1="35.28" y1="41.5" x2="19.69" y2="32.5" stroke={stroke} strokeWidth="5" />
        <line x1="35.28" y1="58.5" x2="19.69" y2="67.5" stroke={stroke} strokeWidth="5" />
        <line x1="50" y1="67"   x2="50"    y2="85"   stroke={stroke} strokeWidth="5" />
        <line x1="64.72" y1="58.5" x2="80.31" y2="67.5" stroke={stroke} strokeWidth="5" />
        <line x1="50" y1="33"   x2="50"    y2="12"   stroke={accent} strokeWidth="7" />
      </g>
      <circle cx="50" cy="50" r="6" fill={dot} />
    </svg>
  );
}
